<template>
    <div class="collapsible-section">
        <div class="collapsible-section-header" :class="{ 'expanded': isExpanded }" @click="toggle">
            <span class="collapsible-section-toggle-icon" :class="{ 'expanded': isExpanded }">▶</span>
            <strong><slot name="title"></slot></strong>
            <div class="collapsible-section-header-extra" @click.stop>
                <slot name="header-extra"></slot>
            </div>
        </div>
        <div v-show="isExpanded" class="collapsible-section-content">
            <slot></slot>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

interface Props {
    defaultExpanded?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    defaultExpanded: false
})

const isExpanded = ref(props.defaultExpanded)

const toggle = () => {
    isExpanded.value = !isExpanded.value
}

defineExpose({
    toggle,
    isExpanded
})
</script>

<style scoped>
.collapsible-section {
    margin-bottom: 8px;
}

.collapsible-section-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    background: #f5f5f5;
    border-radius: 4px;
    cursor: pointer;
    user-select: none;
    border: 1px solid #e0e0e0;
    position: relative;
}

.collapsible-section-header-extra {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 4px;
}

.collapsible-section-header.expanded {
    margin-bottom: 6px;
}

.collapsible-section-header:hover {
    background: #eeeeee;
}

.collapsible-section-toggle-icon {
    font-size: 10px;
    color: #666;
    transition: transform 0.2s;
    display: inline-block;
}

.collapsible-section-toggle-icon.expanded {
    transform: rotate(90deg);
}

.collapsible-section-content {
    margin-bottom: 8px;
}
</style>

